import React from 'react'
import { PriceDisplay } from 'src/features/retails/normal/PriceDisplay' // retailsから importしているの不自然
import { Box } from '@mui/material'
import { Brand, Position, State } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import {
  calculatorOfBaseCost,
  calculatorOfEmbroideryCost,
  calculatorOfOptionCost,
  isOrderFromKoreaChecker
} from 'src/features/simulationConfirm/helper'
import { usModelOfAtomsChecker } from 'src/features/brands/atoms/helper'

type Props = {
  state: State
  brand: Brand
  position: Position
}
export const PriceArea: React.FC<Props> = ({ state, brand, position }) => {
  const { t } = useLocale()
  const productNumber = state?.baseModel.productNumber
  const isUsModel = usModelOfAtomsChecker(productNumber)

  // gorilla, treasureは seriesが変わる
  const seriesOrKindsValue = ['atoms', 'treasure'].includes(state.baseModel?.brand) ? state.kinds?.value : state.series?.value
  const isOrderFromKorea = isOrderFromKoreaChecker(state.baseModel?.productNumber)
  const basePrice = calculatorOfBaseCost(state.baseModel, seriesOrKindsValue)
  const embroideryPrice = calculatorOfEmbroideryCost(brand, t, isOrderFromKorea, state)
  const optionPrice = calculatorOfOptionCost(brand, position, state)
  const totalPrice = basePrice + embroideryPrice + (optionPrice || 0)

  return (
    <Box border={'solid 1px #eee'} p={1} my={1}>
      <PriceDisplay priceLabel={t.BASE_PRICE} priceValue={basePrice} isUsModel={isUsModel} />
      <PriceDisplay priceLabel={t.EMBROIDERY_PRICE} priceValue={embroideryPrice} isUsModel={isUsModel} />
      <PriceDisplay priceLabel={t.OPTION_PRICE} priceValue={optionPrice} isUsModel={isUsModel} />
      <PriceDisplay priceLabel={t.TOTAL_PRICE} priceValue={totalPrice} isUsModel={isUsModel} />
    </Box>
  )
}
